<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import { isLightModule } from '@utils'
const templeModules = ['treasury', 'puja', 'pudu']
export default {
  page: {
    title: '新增項目',
    meta: [{ name: 'description', content: 'Add Product' }],
  },
  components: {
    Layout,
    BaseSteps: () => lazyLoadComponent(import('@components/BaseSteps')),
    Step1: () => lazyLoadComponent(import('./components/Step1Basic')),
    Step2: () => lazyLoadComponent(import('./components/Step2Inventory')),
    Step3: () => lazyLoadComponent(import('./components/Step3Price')),
    Step4: () => lazyLoadComponent(import('./components/Step4ExtraField')),
    Step5: () => lazyLoadComponent(import('./components/Step5State')),

    // 光明燈 斗燈（禮斗）
    Step1_light: () => lazyLoadComponent(import('./components/ibobee/StepBasic')),
    Step2_light: () => lazyLoadComponent(import('./components/ibobee/StepYearAndLight')),
    Step3_light: () => lazyLoadComponent(import('./components/ibobee/StepExtraField')),
    Step4_light: () => lazyLoadComponent(import('./components/Step5State')),

    // 補庫 贊普 法會
    Step1_festival: () => lazyLoadComponent(import('./components/ibobee/StepBasic')),
    Step2_festival: () => lazyLoadComponent(import('./components/ibobee/StepInventory')),
    Step3_festival: () => lazyLoadComponent(import('./components/Step3Price')),
    Step4_festival: () => lazyLoadComponent(import('./components/ibobee/StepExtraField')),
    Step5_festival: () => lazyLoadComponent(import('./components/Step5State')),
  },
  props: {
    defaultStep: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      default: 'activity',
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tryingNextStep: false,
      nextStepButtonVisible: false,
      activeStep: this.defaultStep,
      templeModules: templeModules,
      stepList: [
        {
          title: '基本資訊',
          description: '請填寫下方欄位',
        },
        {
          title: '時段',
          description: '想要在什麼時間讓客戶參與活動呢？可以設定多重時段及重複週期喔！暫不編輯時段，請按離開，完成時段編輯，請按下一步。',
        },
        {
          title: '購買方案',
          description: '可以設定各式各樣的購買方案讓客戶選擇，請將購買方案所包含的項目或使用方式寫在內容中。暫不編輯購買方案，請按離開，完成購買方案編輯，請按下一步。',
        },
        {
          title: templeModules.includes(this.productType) ? '登記資訊' : '自訂問題',
          description: '想知道客戶是如何得知你們的嗎？或是需要統計餐點數量提前做準備嗎？可以自訂問題與客戶互動喔～完成或想略過額外欄位新增請按下一步。',
        },
        {
          title: '設定上下架',
          description: '是否上架？',
        },
      ],
      stepListLight: [
        {
          title: '基本資訊',
          description: '新增點燈服務方便信眾上網點燈',
        },
        {
          title: '年份與燈種',
          description: '請將每年欲販售的燈種資料設定於此。暫不設定請按離開，完成燈種設定，請按下一步。',
        },
        {
          title: '登記資訊',
          description: '可以在此設定點燈所需的信眾資訊（如姓名、生辰等）。設定完成請按下一步。',
        },
        {
          title: '設定上下架',
          description: '是否上架？',
        },
      ],
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
    activeStepComponent() {
      if (this.activeStep === 3) return `step-2_light`
      if (this.activeStep === 4) return `step-3_light`
      if (this.activeStep === 5) return `step-4_light`
      return `step-${this.activeStep}_light`
    },
    activeBaseStep() {
      if (this.activeStep === 3) return 2
      if (this.activeStep === 4) return 3
      return this.activeStep
    },
    headerDescription() {
      let descriptions
      if (this.productType !== 'light' && this.productType !== 'worshipset') {
        descriptions = this.stepList
        return descriptions[this.activeStep - 1].description
      } else {
        descriptions = this.stepListLight
        if (this.activeStep === 3) return descriptions[2 - 1].description
        if (this.activeStep === 4) return descriptions[3 - 1].description
        if (this.activeStep === 5) return descriptions[4 - 1].description
        return descriptions[this.activeStep - 1].description
      }
    },
  },
  methods: {
    isLightModule,
    handleFormValidate(valid) {
      this.nextStepButtonVisible = valid
    },
    onClickLeave() {
      this.$confirm(
        this.$t('PRODUCT.LEAVE_ADD_CONFIRM_MESSAGE', {
          name: this.$t(`PRODUCT.${this.productType}.NAME`),
        }),
        '您將離開此頁面',
        {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
        }
      ).then(() => {
        this.$router.push({ name: 'products' })
      })
    },
    handleStorePrice(storeData) {
      return this.$store.dispatch('product/storePrices', {
        productId: this.productId,
        storeData,
      })
    },
    handleStoreInventory(submitData) {
      return this.$store.dispatch('inventory/storeGroups', {
        productId: this.productId,
        submitData,
      })
    },
    handleStoreProduct(submitData) {
      const storeData = {
        ...submitData,
        type: this.productType,
        staffs: submitData.staffs.map((staff) => {
          return {
            id: staff.id,
            hostTitle: staff.hostTitle,
          }
        }),
      }
      return this.$store.dispatch('product/store', storeData)
    },
    handleStoreExtraField(submitData) {
      const extraFields = [...submitData.byOrder, ...submitData.bySize]
      const storeData = {
        productId: this.productId,
      }
      if (extraFields.length > 0) storeData.extraFields = extraFields
      return this.$store.dispatch('product/updateExtraField', storeData)
    },
    incrementActiveStep() {
      if (this.activeStep++ === this.stepList.length) this.activeStep = 1
      this.tryingNextStep = false
    },
    async onClickNextStep() {
      this.tryingNextStep = true
      try {
        switch (this.activeStep) {
          case 1:
            const formData = this.$refs.step.submitData
            await this.$refs.step.validate()
            const newProduct = await this.handleStoreProduct(formData)
            const routeTo = this.$router.resolve({
              params: { productId: newProduct.id },
            })
            this.$router.push(routeTo.location)
            this.incrementActiveStep()

            break
          case 2:
            const { groups } = this.$refs.step
            await this.handleStoreInventory(groups)
            this.incrementActiveStep()

            break
          case 3:
            try {
              const { params } = this.$refs.step
              await this.handleStorePrice(params)
            } catch {
              return
            }

            this.incrementActiveStep()

            break
          case 4:
            const list = this.$refs.step.list
            await this.handleStoreExtraField(list)
            this.incrementActiveStep()

            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },
    async onClickNextStepLight() {
      this.tryingNextStep = true
      try {
        switch (this.activeStep) {
          case 1:
            const formData = this.$refs.step.submitData
            await this.$refs.step.validate()
            const newProduct = await this.handleStoreProduct(formData)
            const routeTo = this.$router.resolve({
              params: { productId: newProduct.id },
            })
            this.$router.push(routeTo.location)
            this.incrementActiveStep()

            break
          case 2:
          case 3:
            this.activeStep = 4
            this.tryingNextStep = false

            break
          case 4:
            const list = this.$refs.step.list
            await this.handleStoreExtraField(list)
            this.incrementActiveStep()

            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },
  },
}
</script>

<template>
  <Layout :class="$style.page">
    <BasePageHeader
      :title="
        $t('GLOBAL.HEADER_ADD_PREFIX', {
          name: $t(`PRODUCT.${productType}.NAME`),
        })
      "
    >
      <BaseSteps v-if="!isLightModule(productType)" slot="center" :active="activeStep" :list="stepList" />
      <BaseSteps v-else slot="center" :active="activeBaseStep" :list="stepListLight" />
    </BasePageHeader>
    <el-card shadow="never" :header="headerDescription" :class="$style['card-wrapper']">
      <keep-alive>
        <component
          :is="`step-${activeStep}_festival`"
          v-if="templeModules.includes(productType)"
          ref="step"
          :item-type="productType"
          :default-value="defaultValue"
          @validate="handleFormValidate"
        ></component>
        <component
          :is="activeStepComponent"
          v-else-if="['light', 'worshipset'].includes(productType)"
          ref="step"
          :item-type="productType"
          :default-value="defaultValue"
          @validate="handleFormValidate"
        ></component>
        <component :is="`step-${activeStep}`" v-else ref="step" :item-type="productType" :default-value="defaultValue" @validate="handleFormValidate"></component>
      </keep-alive>
    </el-card>
    <div v-show="activeStep !== stepList.length" :class="$style.footer">
      <el-button data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>

      <template v-if="productType !== 'light'">
        <el-button
          v-if="activeStep === 1 ? true : nextStepButtonVisible"
          data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
          type="primary"
          :loading="tryingNextStep"
          @click="onClickNextStep"
          >下一步</el-button
        >
      </template>
      <template v-else>
        <el-button
          v-if="activeStep === 1 ? true : nextStepButtonVisible"
          data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
          type="primary"
          :loading="tryingNextStep"
          @click="onClickNextStepLight"
          >下一步</el-button
        >
      </template>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
